import * as React from "react";
import {FC} from "react";

export const UserSettingsDocuments: FC = () => {
    return <p>helo</p>;
};
